import { GetStaticProps, NextPage } from 'next'
import { serverSideTranslations } from '@/utils/i18n'
import { useTranslation } from 'next-i18next'
import { VerticalNavDefaultPageTemplate } from '@components/templates/VerticalNavDefaultPageTemplate'
import { SessionContentTemplate } from '@components/templates/SessionContentTemplate'
import { SignUpSection } from '@components/organisms/SignUpSection'
import { SignUpFooter } from '@components/molecules/SignUpFooter'
import { MyHead } from '@components/molecules/MyHead'

const Signup: NextPage = () => {
  const { t } = useTranslation(['signup'])
  return (
    <VerticalNavDefaultPageTemplate>
      <MyHead title={t('新規登録')} />
      <SessionContentTemplate title={t('新規登録')} footer={<SignUpFooter />}>
        <SignUpSection />
      </SessionContentTemplate>
    </VerticalNavDefaultPageTemplate>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['global', 'validation', 'signup'])),
  },
})

export default Signup
